import React from 'react';
import { useSelector } from 'react-redux';

import type { ListType } from '~/components-ds/ReviewList';
import ReviewList from '~/components-ds/ReviewList';
import { COVER_DETAILS_BUSINESS_INTERRUPTION_ROUTE } from '~/constants/routes';
import { useAppContent, useCoverDetails } from '~/hooks';
import { selectIsPropertyOwner } from '~/selectors/selectBusinessDetails';
import { Cover } from '~/types/cover';
import { CurrencyFormat, currencyFormatter } from '~/utils/currencyFormatter';

const ReviewBusinessInterruptions: React.FC = () => {
  const { getTextContent } = useAppContent({ basePath: 'dsme.review.fields.businessInterruption' });

  const { indemnityPeriod, grossIncome } = useCoverDetails();
  const isPropertyOwner = useSelector(selectIsPropertyOwner);

  const coverDetailsReviewList = [
    {
      label: getTextContent('indemnityPeriod'),
      data: indemnityPeriod?.toString(),
    },
    {
      label: isPropertyOwner ? getTextContent('rentalIncome') : getTextContent('grossIncome'),
      data: currencyFormatter(grossIncome, CurrencyFormat.Comma),
    },
  ];

  return (
    <ReviewList
      list={
        coverDetailsReviewList.reduce(
          (prev, curr, idx) => ({
            ...prev,
            [String(idx)]: {
              id: idx,
              name: curr.label,
              label: curr.label,
              value: curr.data,
            },
          }),
          {}
        ) as ListType
      }
      title={Cover.BusinessInterruption}
      editRoute={COVER_DETAILS_BUSINESS_INTERRUPTION_ROUTE}
    />
  );
};

export default ReviewBusinessInterruptions;
